import { screen } from 'components/styles/variables';
import { DetailedHTMLProps, ButtonHTMLAttributes } from 'react';
import rightArrow from 'public/static/images/vdp/right-arrow-circle.svg';
import rightArrowDisabled from 'public/static/images/vdp/right-arrow-circle-disabled.svg';
import leftArrow from 'public/static/images/vdp/left-arrow-circle.svg';
import leftArrowDisabled from 'public/static/images/vdp/left-arrow-circle-disabled.svg';

export enum Directions {
  Left,
  Right,
}

export interface ArrowProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  direction: Directions;
}

export function CircleArrow({ direction, ...otherProps }: ArrowProps): JSX.Element {
  const isLeft = direction === Directions.Left;

  return (
    <>
      <button className="arrow-image" {...otherProps} />
      <style jsx>{`
        button {
          height: 72px;
          width: 66px;
          border-radius: 8px;
          border: none;
          display: flex;
          justify-content: center;
          align-items: center;
          background: none;
          outline: none;
          display: none;
          cursor: pointer;
        }

        @media (min-width: ${screen.mdMin}) {
          button {
            display: flex;
          }
        }

        .arrow-image {
          background-image: ${isLeft ? `url(${leftArrow})` : `url(${rightArrow})`};
        }

        .arrow-image:hover {
          cursor: pointer;
          background-image: ${isLeft ? `url(${leftArrowDisabled})` : `url(${rightArrowDisabled})`};
        }
      `}</style>
    </>
  );
}
